import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import "./registerServiceWorker";
import "leaflet/dist/leaflet.css";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(Toast, {
  position: POSITION.TOP_CENTER,
  timeout: 3000,
});
Vue.prototype.$baseUrl = process.env.VUE_APP_baseUrl;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
